<section class="main">
    <div class="sections">
        <section class="top">
            <img class="img" src="./../../../../assets/png/cross.png" alt="">
        </section>
        <section class="footer">
            <h1>Verificación incompleta</h1>
            <p>Falló la verificación <br> de la cuenta</p>
            <a class="botonInicio" mat-raised-button href="index.html" >Volver a inicio</a>
        </section>
    </div>
</section>
